/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        boxSize: 6
    },
    variants: {
        rejected: {
            color: 'stokkeFunctional.alertRed',
            boxSize: 4
        },
        accepted: {
            color: 'stokkeFunctional.alertGreen',
            boxSize: 4
        },
        darkBackground: {
            color: 'stokkeCore.white'
        },
        tooltip: {
            boxSize: 4,
            mx: 0,
            verticalAlign: 'baseline'
        },
        placeOrder: {
            boxSize: 5,
            mx: 2
        },
        footerChevron: {
            color: 'stokkeCore.black',
            width: '16px',
            height: '16px',
            boxSize: 4
        },
        navigation: {
            display: {base: 'none', lg: 'inline-block'},
            boxSize: 4,
            px: 0,
            py: '1px'
        },
        newsletterSubscribe: {
            width: 4,
            height: 4
        }
    }
}
